// TODO: This should live in the eligibility file folder as a component called selector
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import fileQueue from 'ember-file-upload/helpers/file-queue';
import TioLoadingSpinner from './tio/loading-spinner.gts';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';
import type RouterService from '@ember/routing/router-service';
import type { Store } from '@warp-drive/core';
import { type UploadFile } from 'ember-file-upload';
import {
  getUploadUrlRequest,
  parseUploadUrlResponse,
  type UploadJobLog,
} from 'tio-data/requests/eligibility-file-actions';
import Switch from 'tio-ui/components/switch';
import { VStack } from 'tio-ui/components/layout';

interface EligibilityFileSelectorSignature {
  Args: {
    toggleFileSelected: (item: UploadJobLog) => void;
    company: CompanyModel;
  };
  Element: HTMLDivElement;
}

export default class EligibilityFileSelectorComponent extends Component<EligibilityFileSelectorSignature> {
  @service declare store: Store;
  @service declare router: RouterService;

  @tracked fileName = '';
  @tracked isLoading = false;
  @tracked showError = false;
  @tracked isForced = false;

  get isAdmin() {
    // TODO: There are other services to figure this out. If routes are moved around this would break.
    return !!this.router.currentRouteName?.includes('authenticated.eligibility.index');
  }

  get showManualToggle() {
    return this.isAdmin && this.isLoading === false;
  }

  fileSelected = async (uploadFile: UploadFile) => {
    const { legacyId, id } = this.args.company;
    if (!id) {
      this.showError = true;
      return;
    }

    const strategy = this.isForced ? 'MANUAL_FORCE_UPDATE' : 'MANUAL';
    this.isLoading = true;
    this.showError = false;
    try {
      const { content } = await this.store.request(
        getUploadUrlRequest(uploadFile.file.name, legacyId, id, strategy)
      );

      this.args.toggleFileSelected(parseUploadUrlResponse(content));
      this.fileName = uploadFile.file.name;
    } catch {
      this.showError = true;
    } finally {
      this.isLoading = false;
    }
  };

  toggleIsForced = (value: boolean) => {
    this.isForced = value;
  };

  <template>
    <VStack ...attributes>
      {{#if this.showManualToggle}}
        <div class="tio-flex-tight">
          <label>{{t "eligibility_files.manual"}}</label>
          <Switch
            @label={{t "eligibility_files.forced"}}
            @checked={{this.isForced}}
            @onChange={{this.toggleIsForced}}
          />
        </div>
      {{/if}}
      {{#if this.fileName}}
        {{this.fileName}}
      {{else}}
        {{#let
          (fileQueue name="eligibility-upload-queue" onFileAdded=this.fileSelected)
          as |queue|
        }}
          {{#if this.isLoading}}
            <TioLoadingSpinner />
          {{else}}
            <label for="file-upload">
              <div
                class="tio-fg-info hover:tio-fg-info-h cursor-pointer border tio-border-info !inline-block p-4"
              >
                {{t "eligibility_files.select_file"}}
              </div>
            </label>
            <input id="file-upload" type="file" accept=".csv" {{queue.selectFile}} class="hidden" />
          {{/if}}
        {{/let}}
      {{/if}}
      {{#if this.showError}}
        <div class="tio-fg-danger tio-text-sm-semibold">
          {{t "eligibility_files.file_upload_error"}}
        </div>
      {{/if}}
    </VStack>
  </template>
}
